module.exports = __webpack_public_path__ + "media/images/soar/gmail_logo-3d1c339314389d099107283db3ae2c0c.png";